$.fn.isScrollable = function () {
    /// <summary>Determines if an element is scrollable or not</summary>
    /// <returns type="Boolean">True if scrollable</returns>

    var elem = $(this);
    return (
    elem.css('overflow') == 'scroll'
        || elem.css('overflow') == 'auto'
        || elem.css('overflow-x') == 'scroll'
        || elem.css('overflow-x') == 'auto'
        || elem.css('overflow-y') == 'scroll'
        || elem.css('overflow-y') == 'auto'
    );
};

$.fn.closestScrollable = function () {

    var elem = $(this), ret;

    elem.parents().each(function (i, el) {

        el = $(el);
        if (el.isScrollable()) {
            ret = el;
            return false;
        }
    })

    return ret || elem;
}

$.fn.scrollToElement = function (useClosestScrollable) {
    /// <summary>Scroll the window to an element</summary>
    /// <returns type="$">Returns the jQuery element</param>

    if (useClosestScrollable) {
        let scrollable = this.closestScrollable();
        if (scrollable) {
            scrollable.scrollTop(this.offset().top);
            return this;
        }
    }

    window.scrollTo(0, this.offset().top);
    return this;
}

$.fn.setLabelWidths = function (args) {
    /// <summary>Sets label widths consistently, allowing text to flow on single line if possible</summary>
    /// <param name="args" type="Object">Option arguments object</param>
    /// <returns type="$">Returns the jQuery element</param>

    if (!args) return;

    var w = this,
        labels = w.find(args.labelSelector),
        maxAllowableWidth = labels.first().css('max-width'),
        maxLabelWidth;

    // if there are no labels return and call after handler is there is one
    if (!labels.length) {
        
        if (isFunc(args.afterSetLabelWidth)) args.afterSetLabelWidth();
        return;
    }

    if (isStr(maxAllowableWidth) && maxAllowableWidth.endsWith('px')) {

        maxAllowableWidth.replace('px', '');
        maxAllowableWidth = parseInt(maxAllowableWidth);
    }

    var setLabelWidth = function () {

        labels.each(function (i, element) {
            
            var width = $(element).width();

            if (!maxLabelWidth || width > maxLabelWidth) {

                maxLabelWidth = width;
            }

            if (maxLabelWidth > maxAllowableWidth) {

                maxLabelWidth = maxAllowableWidth;
                return false;
            }
        });

        if (maxLabelWidth) {

            var widthPush = maxLabelWidth + 20;
            labels.width(widthPush);
            labels.css('margin-left', (-1 * widthPush) + 'px');
            w.css('padding-left', widthPush + 'px');
        }

        if (isFunc(args.afterSetLabelWidth)) args.afterSetLabelWidth();
    }

    var ensureLabelHasWidth = function() {

        var ensured;

        labels.each(function (i, el) {

            if ($(el).width() > 0) ensured = true;
        });

        return ensured;
    }

    // if DOM isn't ready yet
    if (!ensureLabelHasWidth()) {

        // set label width when dom is ready, repeat 50 times over 2.5 seconds
        cafm.util.doWhen(setLabelWidth, function () {
            return ensureLabelHasWidth()
        }, 50, 50, setLabelWidth);
        // if DOM is never ready then worst case the data will just display as is - not the end of the world and probably never going to happen
    }
    else {

        setLabelWidth();
    }

    return this;
}


$.fn.scaleImageToViewPort = function (space) {
    /// <summary>Resizes down an element relative to the viewport, allowing toal space to be set</summary>
    /// <param name="space" type="Integer">Total space to leave between the element and the viewport</param>
    /// <returns type="$">Returns the jQuery element</param>

    this.each(function (i, el) {

        var element = $(el);
        var w, h;

        if (!element.data('originalWidth')) {

            w = element.width();
            h = element.height();
            element.data('originalWidth', w);
            element.data('originalHeight', h);
        }
        else {

            w = element.data('originalWidth');
            h = element.data('originalHeight');
        }

        var vw = cafm.util.viewPortWidth(),
            vh = cafm.util.viewPortHeight(),
            nw, nh, scale;
        
        if (w > h && (vw - w) < space) {

            nw = vw - space;
            scale = w / nw;
            nh = h / scale;
            element.css('width', nw + 'px');
            element.css('height', nh + 'px');

            w = nw;
            h = nh;
        }

        if ((vh - h) < space) {

            nh = vh - space;
            scale = h / nh;
            nw = w / scale;
            element.css('height', nh + 'px');
            element.css('width', nw + 'px');
        }
        else {

            element.css('height', h + 'px');
            element.css('width', w + 'px');
        }
    });

    return this;
}

$.fn.setupImageThumbWithPopupWindow = function (args) {
    /// <summary>Creates an image thumbnail and hooks up click event to show the larger image</summary>
    /// <param name="args" type="Object">The method args to setup the image thumbnail and click event to show the larger image</param>
    /// <returns type="$">Returns the jQuery thumbnail link element or html string depeding on the returnType arg option. Default is a jquery element.</param>
    
    var replaceGuid = cafm.guid.newGuid(), element = this;

    cafm.util.callFunctionAsync({

        func: function () {

            var link = $('<a class="image-link" title="{2}"><img class="image-link-thumb" src="{0}" alt="{1}" /></a>'.format(args.thumbUrl, args.alt, args.linkTitle));

            link.find('.image-link-thumb').error(function (e) {
                var img = $(e.currentTarget)
                img.attr('src', cafm.url.get('Content/Themes/Default/Images/image-not-found.png'));
                if (args.errorThumbWidth) img.css('width', '{0}px'.format(args.errorThumbWidth));
            });

            $('[data-replaceid="{0}"]'.format(replaceGuid)).replaceWith(link);

            element.find('.image-link').off('click.cafm').on('click.cafm', function (e) {

                var link = $(e.currentTarget),
                    image = link.find('img'),
                    landscape = image.width() > image.height(),
                    paramName = landscape ? 'maxWidth' : 'maxHeight',
                    paramValue = landscape ? cafm.util.viewPortWidth() : cafm.util.viewPortHeight(),
                    imgUrl = isFunc(args.imageUrl) ? args.imageUrl(link) : args.imageUrl;
                
                var img = $('<img />', {
                    src: '{0}{1}{2}={3}'.format(imgUrl, imgUrl.indexOf('?') > -1 ? '&' : '?', paramName, paramValue),
                    alt: args.alt
                });
                
                $('#main').showLoader()

                img.load(function () {

                    $('#main').hideLoader();

                    img.appendTo(cafm.views.mainView());

                    img.showElementInWindow({
                        title: args.title,
                        space: 100
                    })
                });

                img.error(function () {

                    $('#main').hideLoader();
                    img.attr('src', cafm.url.get('Content/Themes/Default/Images/image-not-found.png'));
                });
            })
        }
    })

    var returnHtml = '<span data-replaceid="{0}"></span>'.format(replaceGuid);

    switch (args.returnType) {

        case 'html':

            return returnHtml;

        default:

            return $(returnHtml);
    }
}

$.fn.moveChildren = function () {

    var container = $(this);

    // move items wuth data-moveto attribute
    $('[data-moveto]', container).each(function (i, el) {

        $('#' + $(el).data('moveto')).find('[data-moveto]').remove();
    });
    $('[data-moveto]', container).each(function (i, el) {

        var mt = $(el), targ = $('#{0}, .{0}'.format(mt.data('moveto')));

        if (targ.length) {

            targ.first().append(mt);
        }
    });

    // move items wuth data-moveto attribute
    $('[data-prependto]', container).each(function (i, el) {

        $('#' + $(el).data('prependto')).find('[data-prependto]').remove();
    });
    $('[data-prependto]', container).each(function (i, el) {

        var mt = $(el), targ = $('#{0}, .{0}'.format(mt.data('prependto')));

        if (targ.length) {

            targ.first().prepend(mt);
        }
    });

    // move items wuth data-moveto attribute
    $('[data-insertafter]', container).each(function (i, el) {

        $('#' + $(el).data('insertafter')).find('[data-insertafter]').remove();
    });
    $('[data-insertafter]', container).each(function (i, el) {

        var mt = $(el), targ = $('#{0}, .{0}'.format(mt.data('insertafter')));

        if (targ.length) {

            mt.insertAfter(targ.first());
        }
    });

    return this;
}

$.fn.viewFullScreen = function () {

    this.each(function (i, element) {

        // go full-screen
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    });
}

$.fn.isOnScreen = function () {

    var win = $(window);

    var viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top;

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};

cafm.dom = {
    _cookiesEnabled: null,
    setCookie(args) {
        if (!args.data) return;                
        if (args.data) {
            //console.info(args.data);
            Object.entries(args.data).forEach(([key, value]) => {
                document.cookie = `${key}=${value};path=${args.path || "/"}`;
            });
        }
    },
    clearCookie(name) {
        // This function will attempt to remove a cookie from all paths.
        let pathBits = location.pathname.split('/');
        let pathCurrent = ' path=';

        // do a simple pathless delete first.
        document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;';

        for (var i = 0; i < pathBits.length; i++) {
            pathCurrent += ((pathCurrent.substr(-1) != '/') ? '/' : '') + pathBits[i];
            document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;' + pathCurrent + ';';
        }
    },
    cookiesEnabled: function() {
        if (cafm.dom._cookiesEnabled === null) {
            document.cookie = "testcookie=1;";
            cafm.dom._cookiesEnabled = (document.cookie.indexOf("testcookie") !== -1) ? true : false;
            document.cookie = "testcookie=1; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
        }
        return cafm.dom._cookiesEnabled;
    },
    getElementVisibleHeightProps: function (el) {

        var scrollable = el.closestScrollable();
        scrollable = scrollable.length ? scrollable : $(window);

        var offsetParent = cafm.util.arrayContains(['relative', 'absolute', 'fixed'], el.css('position')) ? el : el.offsetParent(),
            scrollTop = scrollable.scrollTop(),
            scrollBot = scrollTop + scrollable.outerHeight(),
            elTop = scrollable.isScrollable() ? el.position().top : el.offset().top,
            elBottom = elTop + el.outerHeight(),
            visibleTop = elTop < scrollTop ? scrollTop : elTop,
            visibleBottom = elBottom > scrollBot ? scrollBot : elBottom,
            visibleOffsetTop;

        if (offsetParent.length && offsetParent.offset().top > 0 && scrollTop > 0) {

            visibleOffsetTop = scrollTop - offsetParent.offset().top;
        }
        else {

            visibleOffsetTop = scrollTop;
        }

        return {
            visibleHeight: Math.max(visibleBottom - visibleTop, 0),
            visibleOffsetTop: visibleOffsetTop
        };
    }
}